import { DASHBOARD_RESOURCES, DASHBOARD_SCOPES, PAGE_NAMES } from 'constant';
import updateUserSegment from 'assets/dashboard/updateSegments.png';
import referralCode from 'assets/dashboard/referralCode.png';

import UpdateUserReferralCodeDashboard from '../updateUserReferralCode';
import UserReferralSegmentDashboard from '../referralSegment';

export const REFERRAL_RESOURCES = {
	updateUserReferralCode: 'updateUserReferralCode',
	referralSegment: 'referralSegment'
};

export const URL = {
	[REFERRAL_RESOURCES.updateUserReferralCode]: `/${PAGE_NAMES.dashboard}/${DASHBOARD_RESOURCES.referral}/${REFERRAL_RESOURCES.updateUserReferralCode}`,
	[REFERRAL_RESOURCES.referralSegment]: `/${PAGE_NAMES.dashboard}/${DASHBOARD_RESOURCES.referral}/${REFERRAL_RESOURCES.referralSegment}`
};

export const LABEL = {
	[REFERRAL_RESOURCES.updateUserReferralCode]: 'Update Referral Code',
	[REFERRAL_RESOURCES.referralSegment]: 'Referral Segment'
};

export const COMPONENT = {
	[REFERRAL_RESOURCES.updateUserReferralCode]: UpdateUserReferralCodeDashboard,
	[REFERRAL_RESOURCES.referralSegment]: UserReferralSegmentDashboard
};

export const GET_ACTION = {
	[REFERRAL_RESOURCES.updateUserReferralCode]: DASHBOARD_SCOPES[DASHBOARD_RESOURCES.referral].updateUserReferralCode,
	[REFERRAL_RESOURCES.referralSegment]: DASHBOARD_SCOPES[DASHBOARD_RESOURCES.referral].getReferralSegmentPolicies
};

export const IMAGE_SOURCE = {
	[REFERRAL_RESOURCES.updateUserReferralCode]: referralCode,
	[REFERRAL_RESOURCES.referralSegment]: updateUserSegment
};

export type Record = {
	[key: string]: string | number | boolean;
};
